import React from 'react';

const AppleIconSvg = (props) => (
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="24" cy="24" r="24" fill="#4B4D63" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.0125 13C27.0152 13.0459 25.7905 13.6789 25.0648 14.5159C24.4073 15.2627 23.8409 16.4617 23.9993 17.6147C25.1108 17.7056 26.2666 17.0496 26.9701 16.2127C27.6727 15.3528 28.1488 14.1768 28.0125 13V13ZM27.9904 17.8416C26.4258 17.6827 24.9294 18.7686 24.1356 18.7686C23.3418 18.7686 22.1171 17.8637 20.8251 17.8866C19.1242 17.9316 17.5597 18.8816 16.6756 20.3974C14.9296 23.4742 16.2446 27.9988 17.9676 30.4867C18.8065 31.6857 19.8269 33.0656 21.1419 32.9976C22.4118 32.9526 22.8879 32.1836 24.4303 32.1836C25.9497 32.1836 26.4028 32.9976 27.7409 32.9755C29.101 32.9526 29.9629 31.7307 30.8019 30.5097C31.7771 29.1068 32.1629 28.5868 32.185 28.5188C32.1629 28.4959 29.532 26.641 29.4868 23.6322C29.4638 21.0984 31.5505 19.8774 31.6638 19.8095C30.4842 18.0905 28.6479 17.8637 27.9904 17.8416V17.8416Z"
            fill="white"
        />
    </svg>
);

export default AppleIconSvg;
